import ServiceExec from '@/common/utils/ServiceExec';

const actions = {
  toggleSidebarColor({ commit }, payload) {
    commit('setSidebarType', payload);
  },

  clearKeepAlive({ commit }) {
    commit('setKeepAlive', []);
  }
};

export default actions;
